export default "__VITE_ASSET__1943053a__"